import { useMemo } from "react";
import BarChart from "../../../components/Charts/BarChart";
import SectionCard from "../../../components/SectionCard";
import { transformGroupedBarChartData } from "../../../utils/hdbDashboardUtils";
import { useDashboard } from "../../../context/HDBDashboardContext";
import styles from "./index.module.scss";
import { noData } from "../../../constants";
import { useDispatch } from "react-redux";
import { setSelectedKpiTab } from "../../../reducers/ProgramReducer";
import { getItemInLocalStorage } from "../../../services/localStorage";

const Demographics = ({ section }) => {
  const { updateFilters } = useDashboard();

  const { labels: xLabels, datasets } = useMemo(
    () => transformGroupedBarChartData(section),
    [section],
  );
  
  const dispatch = useDispatch();
  const handleBarClick = ({ filterInfo }) => {
    if (filterInfo) {
      updateFilters(filterInfo);
      if(filterInfo?.kpiFilter){
      dispatch(
        setSelectedKpiTab({
          kpiFilter: filterInfo?.kpiFilter,
          kpiCategory: filterInfo.kpiCategory,
        }),
      );
    }
    else{
       const formConfig = getItemInLocalStorage('filterConfig');
       dispatch(setSelectedKpiTab(formConfig?.data?.parentOptions[0]?.kpiOptions[0]));
    }
    }
  };

  return (
     <SectionCard title={section?.displayName}>
    {section?.count ? (
      <BarChart
        labels={xLabels}
        datasets={datasets}
        colors={["#2F73F1", "#FF60A5"]}
        stacked={true}
        showLegend={true}
        onBarClick={handleBarClick}
      />
    ) : (
      <div className={styles.noData}>
        {noData}
      </div>
    )}
  </SectionCard>
   
  );
};

export default Demographics;